<template>
  <project-assessment-view
    :assessment="assessment"
    @set_key_value="set_key_value"
    @remove="$emit('remove')"
  >
    <assessment-code
      :value="assessment.assessment_code"
      @input="set_state({ assessment_code: $event ? $event.id : null })"
    />

    <template v-if="assessment.assessment_code">
      <div v-if="assessment.assessment_code === 247">
        <div class="title">Выберите компетенции</div>
        <multiselect
          :value="selectedNavigatorModels"
          :options="navigatorModelOptions"
          :show-labels="false"
          :allow-empty="false"
          :close-on-select="false"
          class="boxy full"
          track-by="id"
          label="name"
          searchable
          multiple
          @input="
            set_key_value({ key: 'navigator_model_params', value: $event.map(item => item.id) })
          "
        />
      </div>

      <norm-groups
        :key="id + '_norm_groups_' + assessment.assessment_code"
        :value="assessment.norm_groups"
        :assessment_id="assessment.assessment_code"
        @input="set_key_value({ key: 'norm_groups', value: $event.map(item => item.id) })"
      />
      <report-options
        :key="id + '_report_options_' + assessment.assessment_code"
        :value="assessment.report_options"
        :assessment_id="assessment.assessment_code"
        @input="set_key_value({ key: 'report_options', value: $event.map(item => item.id) })"
      />
      <report-scales
        :key="id + '_report_scales_' + assessment.assessment_code"
        :value="assessment.report_scales"
        :assessment_id="assessment.assessment_code"
        @input="set_key_value({ key: 'report_scales', value: $event.map(item => item.id) })"
      />
      <pdf-report-types
        :key="id + '_pdf_report_types_' + assessment.assessment_code"
        :value="assessment.pdf_report_types"
        :assessment_id="assessment.assessment_code"
        @input="set_key_value({ key: 'pdf_report_types', value: $event.map(item => item.id) })"
      />
      <pdf-report-options
        :key="id + '_pdf_report_options_' + assessment.assessment_code"
        :value="assessment.pdf_report_options"
        :assessment_id="assessment.assessment_code"
        @input="set_key_value({ key: 'pdf_report_options', value: $event.map(item => item.id) })"
      />
    </template>
  </project-assessment-view>
</template>

<script>
  import { PROJECT_ASSESSMENT_STORE_PREFIX } from '@/stores_new/vacancy_talentq/project_form/constants';
  import ProjectAssessmentView from '../../components/project/project-assessment-view';
  import AssessmentCode from '../assessment/assessment-code';
  import NormGroups from '@/routes_new/inner/vacancy/talentq/controllers/assessment/norm-groups';
  import ReportOptions from '@/routes_new/inner/vacancy/talentq/controllers/assessment/report-options';
  import ReportScales from '@/routes_new/inner/vacancy/talentq/controllers/assessment/report-scales';
  import PdfReportTypes from '@/routes_new/inner/vacancy/talentq/controllers/assessment/pdf-report-types';
  import PdfReportOptions from '@/routes_new/inner/vacancy/talentq/controllers/assessment/pdf-report-options';

  export default {
    name: 'ProjectAssessment',

    components: {
      PdfReportOptions,
      PdfReportTypes,
      ReportScales,
      ReportOptions,
      NormGroups,
      AssessmentCode,
      ProjectAssessmentView
    },

    props: {
      id: {
        type: [String, Number],
        required: true
      }
    },

    data() {
      return {
        navigatorModelOptions: [
          { id: 1, name: 'Широта мышления' },
          { id: 2, name: 'Работа в команде' },
          { id: 3, name: 'Социальная смелость' },
          { id: 4, name: 'Адаптация к изменениям' },
          { id: 5, name: 'Лидерство' },
          { id: 6, name: 'Ориентация на достижения' },
          { id: 7, name: 'Энергичность' },
          { id: 8, name: 'Оказание влияния' },
          { id: 9, name: 'Планирование и организация' },
          { id: 10, name: 'Инновативность' },
          { id: 11, name: 'Анализ информации' },
          { id: 12, name: 'Решительность' },
          { id: 13, name: 'Понимание людей' },
          { id: 14, name: 'Оказание поддержки' },
          { id: 15, name: 'Ответственность' },
          { id: 16, name: 'Следование правилам' },
          { id: 17, name: 'Стратегический фокус' },
          { id: 18, name: 'Цифровое мышление' },
          { id: 19, name: 'Социальная ответственность' },
          { id: 20, name: 'Саморазвитие' },
          { id: 21, name: 'Коммерческое мышление' },
          { id: 22, name: 'Развитие других' },
          { id: 23, name: 'Ориентация на клиентов' },
          { id: 24, name: 'Постановка задач и контроль' },
          { id: 25, name: 'Позитивное мышление' },
          { id: 26, name: 'Построение сети контактов' },
          { id: 27, name: 'Безопасное поведение' },
          { id: 28, name: 'Ориентация на качество' },
          { id: 29, name: 'Публичные выступления' },
          { id: 30, name: 'Управление изменениями' },
          { id: 31, name: 'Инициативность и самостоятельность' },
          { id: 32, name: 'Стрессоустойчивость' },
          { id: 33, name: 'Самопрезентация' }
        ]
      };
    },

    computed: {
      store_key() {
        return PROJECT_ASSESSMENT_STORE_PREFIX + this.id;
      },

      assessment() {
        return this.$store.getters[this.store_key + '/assessment'];
      },

      selectedNavigatorModels() {
        if (!this.assessment.navigator_model_params || !this.navigatorModelOptions.length)
          return null;
        if (typeof this.assessment.navigator_model_params === 'number')
          return this.navigatorModelOptions.find(
            item => item.id === this.assessment.navigator_model_params
          );

        return this.assessment.navigator_model_params.map(id =>
          this.navigatorModelOptions.find(item => item.id === id)
        );
      }
    },

    methods: {
      set_key_value(payload) {
        return this.$store.commit(this.store_key + '/set_key_value', payload);
      },

      set_state(payload) {
        payload.accept_level = this.assessment.accept_level;
        return this.$store.commit(this.store_key + '/set_state', payload);
      }
    }
  };
</script>

<style lang="scss">
  .title {
    font-weight: 500 !important;
  }
  .full {
    width: 100% !important;
    max-width: 100% !important;
  }
</style>
